import m from "../../es2015/lang/da_DK";
window.am4lang_da_DK = m;


//////////////////
// WEBPACK FOOTER
// ./lang/da_DK.js
// module id = null
// module chunks = 